import { render, staticRenderFns } from "./FileShowData.vue?vue&type=template&id=0b76fe7f&"
import script from "./FileShowData.vue?vue&type=script&lang=js&"
export * from "./FileShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports